/**
 * Config defines configuration of the file
 * CompanyID=0 represent to default SinerpayApp ID
 * COMPANYID considered as projectID because each
 * mini project belongs to different client.
 */
const COMPANYID = 0;
export { COMPANYID };
